import { render, staticRenderFns } from "./Validated.vue?vue&type=template&id=67cb048c&"
import script from "./Validated.vue?vue&type=script&lang=js&"
export * from "./Validated.vue?vue&type=script&lang=js&"
import style0 from "./Validated.vue?vue&type=style&index=0&id=67cb048c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports